import { BotDifficulty, MapSettingEnum } from '@colonist/game-base-types';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
function sendBotsTabAnalytic(type, mapSetting, dimensions) {
    const eventData = {
        type: type,
        category: AnalyticEventCategory.Matchmaking,
        stringValue: MapSettingEnum[mapSetting],
        dimensions: dimensions
    };
    void CA.sendAnalyticEvent(eventData);
}
export function sendBotsTabMapSelectedAnalytic(mapSetting, isLocked) {
    sendBotsTabAnalytic(AnalyticEventType.BotsTabMapSelected, mapSetting, {
        isLocked: isLocked
    });
}
export function sendBotsTabMembershipCTAClickedAnalytic(mapSetting) {
    sendBotsTabAnalytic(AnalyticEventType.BotsTabMembershipCTAClicked, mapSetting);
}
export function sendBotsTabRushDifficultySelectedAnalytic(difficulty) {
    const eventData = {
        type: AnalyticEventType.BotsTabRushDifficultySelected,
        category: AnalyticEventCategory.Matchmaking,
        stringValue: BotDifficulty[difficulty]
    };
    void CA.sendAnalyticEvent(eventData);
}
